import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { services } from '../../data/services';
import { cities } from '../../data/cities';
import { storySeo } from '../../data/bradStory';

const titles = { services: 'Milling Services', 'service-areas': 'North Texas Service Areas', projects: 'Projects', equipment: 'Equipment Planning', about: 'About', careers: 'Careers', contact: 'Contact', 'request-a-quote': 'Request a Quote', resources: 'Milling Resources', subcontractors: 'Subcontractors', portal: 'Secure Workspace', admin: 'Owner Setup', 'privacy-policy': 'Draft Privacy Policy', 'terms-of-use': 'Draft Terms of Use', accessibility: 'Draft Accessibility Statement' };

export const RouteEffects = () => {
  const location = useLocation();
  useEffect(() => {
    const [section, slug] = location.pathname.split('/').filter(Boolean);
    const service = section === 'services' && services.find(item => item.slug === slug);
    const city = section === 'service-areas' && cities.find(item => item.slug === slug);
    const invalidDetail = slug && ((section === 'services' && !service) || (section === 'service-areas' && !city));
    const subTitles = { register: 'Subcontractor Registration', login: 'Subcontractor Login', 'password-help': 'Account Help', forms: 'Subcontractor Forms', insurance: 'Insurance Requirements', resources: 'Vendor Resources' };
    const title = invalidDetail ? 'Page Not Found' : service?.title || (city ? `Asphalt Milling in ${city.name}, TX` : section === 'subcontractors' && slug ? subTitles[slug] : titles[section]);
    document.title = title ? `${title} | Longhorn Milling` : section ? 'Page Not Found | Longhorn Milling' : 'Longhorn Milling';
    document.querySelector('meta[name="description"]')?.setAttribute('content', service?.summary || city?.intro || (title ? `${title} from Longhorn Milling. Explore information and send an inquiry.` : 'Longhorn Milling — precision asphalt milling across North Texas. Call 214-815-5966 to discuss your project.'));
    if (section === 'our-story') {
      document.title = storySeo.title;
      document.querySelector('meta[name="description"]')?.setAttribute('content', storySeo.description);
    }
    if (location.hash) {
      requestAnimationFrame(() => document.getElementById(location.hash.slice(1))?.scrollIntoView());
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  }, [location.pathname, location.hash]);
  return null;
};